<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-select ttLabel="main_resource" [ttModel]="page.main_resource_id" (ttModelChange)="onMainResourceChanged($event)" [ttData]="mainResources" ttDataId="item_id" ttDataName="item_name" ttRememberId="w_srcrewresourceview.main_resource_id" ttOnlyRemember></tt-select>
        <tt-select ttLabel="sub_resource" [ttModel]="page.sub_resource_id" (ttModelChange)="onSubResourceChanged($event)" [ttData]="subResources" ttDataId="item_id" ttDataName="item_name" ttRememberId="w_srcrewresourceview.sub_resource_id" ttOnlyRemember></tt-select>
        <tt-list [ttData]="resourceViews" ttBadge="badge"></tt-list>
    </tt-card>
</tt-page>
